import { useReducer, useRef } from 'react';

const initialState = {
    isDrawing: false,
    currentStroke: null,
    lastPoint: null,
    isAreaErasing: false,
    eraserStartPoint: null,
    eraserEndPoint: null,
    isCanvasLargerThanContainer: false
};

const drawingReducer = (state, action) => {
    switch (action.type) {
        case 'START_DRAWING':
            return { 
                ...state, 
                isDrawing: true, 
                currentStroke: action.payload,
                lastPoint: action.payload?.points?.[0] || null
            };
        case 'UPDATE_STROKE':
            return { 
                ...state, 
                currentStroke: action.payload.stroke,
                lastPoint: action.payload.lastPoint
            };
        case 'STOP_DRAWING':
            return { 
                ...state, 
                isDrawing: false, 
                currentStroke: null,
                lastPoint: null
            };
        case 'START_AREA_ERASING':
            return { 
                ...state, 
                isAreaErasing: true, 
                eraserStartPoint: action.payload 
            };
        case 'UPDATE_ERASER':
            return { ...state, eraserEndPoint: action.payload };
        case 'STOP_AREA_ERASING':
            return { 
                ...state, 
                isAreaErasing: false, 
                eraserStartPoint: null,
                eraserEndPoint: null
            };
        case 'SET_CANVAS_LARGER':
            return { ...state, isCanvasLargerThanContainer: action.payload };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};

export const useDrawing = () => {
    const [state, dispatch] = useReducer(drawingReducer, initialState);
    const currentStrokeRef = useRef(null);

    const actions = {
        startDrawing: (stroke) => {
            currentStrokeRef.current = stroke;
            dispatch({ type: 'START_DRAWING', payload: stroke });
        },
        updateStroke: (stroke, lastPoint) => {
            currentStrokeRef.current = stroke;
            dispatch({ type: 'UPDATE_STROKE', payload: { stroke, lastPoint } });
        },
        stopDrawing: () => {
            currentStrokeRef.current = null;
            dispatch({ type: 'STOP_DRAWING' });
        },
        startAreaErasing: (point) => dispatch({ type: 'START_AREA_ERASING', payload: point }),
        updateEraser: (point) => dispatch({ type: 'UPDATE_ERASER', payload: point }),
        stopAreaErasing: () => dispatch({ type: 'STOP_AREA_ERASING' }),
        setCanvasLarger: (isLarger) => dispatch({ type: 'SET_CANVAS_LARGER', payload: isLarger }),
        reset: () => {
            currentStrokeRef.current = null;
            dispatch({ type: 'RESET' });
        }
    };

    return [state, actions, currentStrokeRef];
};
